import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as queryString from 'query-string';

import PickleballSelfRatingForm from './PickleballSelfRatingForm';
import { postPickleballRangeSurvey, postPickleballSurveyV2, skipPickleballSurveyV2 } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';

const PickleballSelfRating = (props) => {
    const { disableRangeSurveySkip, isFromOnboarding, location = {} } = props;
    const queryParams = location.search;

    const dispatch = useDispatch();
    const history = useHistory();

    const handleSubmit = (values) => {
        if (isFromOnboarding) {
            dispatch(postPickleballSurveyV2(values));
        } else {
            dispatch(postPickleballRangeSurvey(values));
        }
    };

    const handleSkip = () => {
        if (isFromOnboarding) {
            dispatch(skipPickleballSurveyV2());
        } else {
            const parsed = queryString.parse(queryParams);
            const redirectUrl = parsed.return || '/';
            history.push(redirectUrl);
        }
    };

    return (
        <div className={styles.pageContent}>
            <div className={styles.title} data-testid="nuo-v2.pickleball-self-rating.title">
                Tell us about your pickleball experience to receive an estimated pickleball rating (UTR-P).
            </div>
            {!disableRangeSurveySkip && (
                <div className={`link clickable d-inline mr32`} onClick={handleSkip} data-testid="nuo-v2.pickleball-self-rating.skip-link">I&apos;ll do this later.</div>
            )}
            <PickleballSelfRatingForm {...props} handleSubmit={handleSubmit} />
        </div>
    );
};

export default PickleballSelfRating;
